import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="mt-20 bg-gradient-to-b from-[#2B160A] to-[#1B110A] border-t border-amber-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="h-14 w-14 overflow-hidden flex items-center justify-center">
                <img
                  src={logo}
                  alt="Gwal Spices logo"
                  className="h-full w-full object-contain"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.parentElement.textContent = "GS";
                  }}
                />
              </div>
              <h3 className="text-2xl font-extrabold tracking-tight text-amber-100">gwalspices</h3>
              <span className="text-[10px] font-bold text-amber-300 border border-amber-500/40 rounded px-1 py-0.5">TM</span>
            </div>
            <p className="text-amber-100/90 leading-relaxed text-sm">
              Premium-grade Indian spices crafted for homes, chefs, and serious kitchens.
            </p>
            <p className="text-xs text-amber-300/90 mt-4">
              No Return Policy: Due to food safety, returns and exchanges are not accepted.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase text-amber-200 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-amber-100/90 hover:text-white transition text-sm">Home</Link></li>
              <li><Link to="/shop" className="text-amber-100/90 hover:text-white transition text-sm">Shop</Link></li>
              <li><Link to="/my-orders" className="text-amber-100/90 hover:text-white transition text-sm">Track Order</Link></li>
              <li><Link to="/contact" className="text-amber-100/90 hover:text-white transition text-sm">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase text-amber-200 mb-4">Customer Support</h4>
            <ul className="space-y-3 text-sm">
              <li className="text-amber-100/90 flex items-center gap-2"><Phone className="h-4 w-4 text-amber-300" />+91 90637 84294</li>
              <li className="text-amber-100/90 flex items-center gap-2"><Mail className="h-4 w-4 text-amber-300" />samridhenterprise24@gmail.com</li>
              <li className="text-amber-100/90 flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-amber-300" />Hyderabad, Telangana, India</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase text-amber-200 mb-4">Follow</h4>
            <div className="flex items-center gap-3 mb-4">
              <a
                href="https://www.instagram.com/gwalspices?igsh=Z3I2ZWVwMWhkd2dq"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg border border-amber-600/40 text-amber-100 hover:text-white hover:border-amber-400 transition"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
            <p className="text-xs text-amber-300/90 leading-relaxed">
              Business hours: Mon-Sat, 10:00 AM to 7:00 PM IST.
            </p>
          </div>
        </div>

        <div className="border-t border-amber-700/40 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-amber-100/90">© 2026 gwalspices TM. All rights reserved.</p>
          <div className="flex items-center gap-4 text-xs">
            <Link to="/privacy" className="text-amber-200/90 hover:text-white transition">Privacy Policy</Link>
            <Link to="/terms" className="text-amber-200/90 hover:text-white transition">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;





